import styled from 'styled-components';

export const Container = styled.div`
  .descricao-turma {      
    margin-bottom: 5px;
    padding: 5px;   
  }

  .icon-turma{ margin-left: 10px; }

  .icon-view {
    cursor: pointer;
  }

  
`;

export const TableTransferencia = styled.table`
  th {
    padding: 4px!important;    
  }

  td {
    font-size: 12px;
    vertical-align: middle;
  }

  .column-turma {
    max-width: 300px;
    font-size: 12px;
    vertical-align: middle;
  }

  .column {
    width: 40px;
    vertical-align: middle;
    text-align: center;
  }

  .column-data-hora{
    width: 80px;
    vertical-align: middle;
    text-align: center;
  }

  .column-view{
    width: 40px;
    vertical-align: middle;
    text-align: center;
  }
  
  .column-nome {
    vertical-align: middle;
  }
  
  .column-ia, .column-nota, .column-faltas{
    width: 45px;
    text-align: center;
    vertical-align: middle;
  }

  .input-ia-header{
    width: 45px!important;
    text-align: center;
    font-size: 10px;
    height: 25px;
  }

  .input-ia{
    width: 45px!important;
    text-align: center;
  }
`;

export const Botoes = styled.div`
    margin-top: 10px;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;

    .alert-info {
      margin-right: 10px;
      margin-bottom: 0px;
      display: flex;
      flex: 1;
    }

`;

export const Formula = styled.div`
  padding: 6px;
`;

